import * as SerializerLib from "jsonapi-serializer";

const JSONAPIError = SerializerLib.Error;
const JSONAPIDeserializer = SerializerLib.Deserializer;

export const serializeError = (data) => new JSONAPIError(data);

export const deserialize = (data, relationship = {}) => {
  try {
    return new JSONAPIDeserializer({
      keyForAttribute: "camelCase",
      ...relationship
    }).deserialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
